<template lang="html">
    <div>
        <Hero imgLink="/img/port.jpg"/>
        <ResetPasswordForm />        
    </div>
</template>
<script>
import Hero from "../components/Hero.vue";
import ResetPasswordForm from "../components/ForgetPassword/ResetPasswordForm.vue";

export default {
  name: "Login",
  components: {
    Hero,
    ResetPasswordForm,
  },
  methods: {},
};
</script>
<style lang="css"></style>